import { ProtocolViewerPanel } from "./ProtocolViewerPanel";

export default ProtocolViewerPanel;
